// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared";
import { equal } from "@lg/shared";
import * as z from "zod";
import { immerable } from "immer";
import { untracked } from "@angular/core";

const $schemas = new Map<string, z.ZodObject<any>>();
@jsonClass('Toolbox.GoalSetting')
class Toolbox__GoalSetting {
    @jsonProperty(() => Toolbox__GoalSetting.Id)
    id: Toolbox__GoalSetting.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "employee", "manager", "status", "status$id", "q_whatWentWell", "q_whatWasDifficult", "q_whatToDevelop", "q_whatSupportNeeded", "q_howDoingOverall", "q_otherComments", "developmentGoals", "performanceGoals", "previousGoalSetting", "previousGoalSettingId", "cycle", "cycleId", "futureDevelopmentGoals", "futurePerformanceGoals", "attachments", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["nextAction", "nextActionDeadline", "nextActionDeadlineStr"] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "employee", "manager", "status", "status$id", "q_whatWentWell", "q_whatWasDifficult", "q_whatToDevelop", "q_whatSupportNeeded", "q_howDoingOverall", "q_otherComments", "developmentGoals", "performanceGoals", "previousGoalSetting", "previousGoalSettingId", "cycle", "cycleId", "futureDevelopmentGoals", "futurePerformanceGoals", "attachments", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber", "nextAction", "nextActionDeadline", "nextActionDeadlineStr"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "employee", "manager", "status", "q_whatWentWell", "q_whatWasDifficult", "q_whatToDevelop", "q_whatSupportNeeded", "q_howDoingOverall", "q_otherComments", "developmentGoals", "performanceGoals", "previousGoalSetting", "previousGoalSettingId", "cycle", "cycleId", "futureDevelopmentGoals", "futurePerformanceGoals", "attachments", "createdOn", "updatedOn", "deletedOn", "versionNumber", "nextAction", "nextActionDeadline", "nextActionDeadlineStr"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "employee": "System.UserIdAndName", "manager": "System.UserIdAndName", "status": "Toolbox.GoalSettingStatus", "status$id": "string", "q_whatWentWell": "This.GoalSettingSelfReviewAnswer", "q_whatWasDifficult": "This.GoalSettingSelfReviewAnswer", "q_whatToDevelop": "This.GoalSettingSelfReviewAnswer", "q_whatSupportNeeded": "This.GoalSettingSelfReviewAnswer", "q_howDoingOverall": "This.GoalSettingSelfReviewAnswer", "q_otherComments": "This.GoalSettingSelfReviewAnswer", "developmentGoals": "Toolbox.GoalSettingGoal[]", "performanceGoals": "Toolbox.GoalSettingGoal[]", "previousGoalSetting": "Toolbox.GoalSetting", "previousGoalSettingId": "Toolbox.GoalSetting.Id", "cycle": "Toolbox.GoalSettingCycle", "cycleId": "Toolbox.GoalSettingCycle.Id", "futureDevelopmentGoals": "Toolbox.GoalSettingGoal[]", "futurePerformanceGoals": "Toolbox.GoalSettingGoal[]", "attachments": "Toolbox.GoalSettingAttachment[]", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "nextAction": "string", "nextActionDeadline": "Date", "nextActionDeadlineStr": "string", "id": "number" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["status"] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["ForSelectionList", "ForList"] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ cycle: () => Toolbox.GoalSettingCycle } as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ developmentGoals: () => Toolbox.GoalSettingGoal, performanceGoals: () => Toolbox.GoalSettingGoal, futureDevelopmentGoals: () => Toolbox.GoalSettingGoal, futurePerformanceGoals: () => Toolbox.GoalSettingGoal, attachments: () => Toolbox.GoalSettingAttachment } as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ previousGoalSetting: () => Toolbox.GoalSetting } as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({ employee: () => System.UserIdAndName, manager: () => System.UserIdAndName, q_whatWentWell: () => Toolbox.GoalSettingSelfReviewAnswer, q_whatWasDifficult: () => Toolbox.GoalSettingSelfReviewAnswer, q_whatToDevelop: () => Toolbox.GoalSettingSelfReviewAnswer, q_whatSupportNeeded: () => Toolbox.GoalSettingSelfReviewAnswer, q_howDoingOverall: () => Toolbox.GoalSettingSelfReviewAnswer, q_otherComments: () => Toolbox.GoalSettingSelfReviewAnswer } as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    static ForSelectionList: typeof Toolbox__GoalSetting__ForSelectionList;
    static ForList: typeof Toolbox__GoalSetting__ForList;
    private readonly θemployee = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θmanager = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θstatus = Signals.proxySignalDeferred<This.GoalSettingStatus>(() => (new This.GoalSettingStatus(This.GoalSettingStatus.Draft)) as any);
    private readonly θq_whatWentWell = Signals.proxySignalDeferred<This.GoalSettingSelfReviewAnswer>(() => (undefined) as any);
    private readonly θq_whatWasDifficult = Signals.proxySignalDeferred<This.GoalSettingSelfReviewAnswer>(() => (undefined) as any);
    private readonly θq_whatToDevelop = Signals.proxySignalDeferred<This.GoalSettingSelfReviewAnswer>(() => (undefined) as any);
    private readonly θq_whatSupportNeeded = Signals.proxySignalDeferred<This.GoalSettingSelfReviewAnswer>(() => (undefined) as any);
    private readonly θq_howDoingOverall = Signals.proxySignalDeferred<This.GoalSettingSelfReviewAnswer>(() => (undefined) as any);
    private readonly θq_otherComments = Signals.proxySignalDeferred<This.GoalSettingSelfReviewAnswer>(() => (undefined) as any);
    private readonly θdevelopmentGoals = Signals.proxySignalDeferred<Toolbox.GoalSettingGoal[]>(() => (undefined) as any);
    private readonly θperformanceGoals = Signals.proxySignalDeferred<Toolbox.GoalSettingGoal[]>(() => (undefined) as any);
    private readonly θpreviousGoalSetting = Signals.proxySignalDeferred<Toolbox.GoalSetting>(() => (undefined) as any);
    private readonly θpreviousGoalSettingId = Signals.proxySignalDeferred<Toolbox.GoalSetting.Id>(() => (undefined) as any);
    private readonly θcycle = Signals.proxySignalDeferred<Toolbox.GoalSettingCycle>(() => (undefined) as any);
    private readonly θcycleId = Signals.proxySignalDeferred<Toolbox.GoalSettingCycle.Id>(() => (undefined) as any);
    private readonly θfutureDevelopmentGoals = Signals.proxySignalDeferred<Toolbox.GoalSettingGoal[]>(() => (undefined) as any);
    private readonly θfuturePerformanceGoals = Signals.proxySignalDeferred<Toolbox.GoalSettingGoal[]>(() => (undefined) as any);
    private readonly θattachments = Signals.proxySignalDeferred<Toolbox.GoalSettingAttachment[]>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Toolbox.GoalSetting' {
        return 'Toolbox.GoalSetting'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Toolbox.GoalSetting' {
        return 'Toolbox.GoalSetting'
    }

    static get __baseType(): 'Toolbox.GoalSetting' {
        return 'Toolbox.GoalSetting'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Toolbox.GoalSetting' {
        return 'Toolbox.GoalSetting'
    }

    get [BoInfoSymbol]() {
        return Toolbox__GoalSetting[BoInfoSymbol]
    }

    get employee(): System.UserIdAndName {
        return this.θemployee?.()
    }

    set employee(employee) {
        this.θemployee.set(LowgileDataUtil.coerceDataType(employee, 'System.UserIdAndName', false, true))
    }

    get manager(): System.UserIdAndName {
        return this.θmanager?.()
    }

    set manager(manager) {
        this.θmanager.set(LowgileDataUtil.coerceDataType(manager, 'System.UserIdAndName', false, true))
    }

    get status(): This.GoalSettingStatus {
        return this.θstatus?.()
    }

    set status(status: This.GoalSettingStatus | This.GoalSettingStatus.Id) {
        this.θstatus().θupdate(status)
    }

    @jsonProperty(String)
    get 'status$id'(): This.GoalSettingStatus.Id {
        return this.θstatus?.()?.id
    }

    set 'status$id'(status: string) {
        this.θstatus().θupdate(status as This.GoalSettingStatus.Id)
    }

    get q_whatWentWell(): This.GoalSettingSelfReviewAnswer {
        return this.θq_whatWentWell?.()
    }

    set q_whatWentWell(q_whatWentWell) {
        this.θq_whatWentWell.set(LowgileDataUtil.coerceDataType(q_whatWentWell, 'This.GoalSettingSelfReviewAnswer', false, true))
    }

    get q_whatWasDifficult(): This.GoalSettingSelfReviewAnswer {
        return this.θq_whatWasDifficult?.()
    }

    set q_whatWasDifficult(q_whatWasDifficult) {
        this.θq_whatWasDifficult.set(LowgileDataUtil.coerceDataType(q_whatWasDifficult, 'This.GoalSettingSelfReviewAnswer', false, true))
    }

    get q_whatToDevelop(): This.GoalSettingSelfReviewAnswer {
        return this.θq_whatToDevelop?.()
    }

    set q_whatToDevelop(q_whatToDevelop) {
        this.θq_whatToDevelop.set(LowgileDataUtil.coerceDataType(q_whatToDevelop, 'This.GoalSettingSelfReviewAnswer', false, true))
    }

    get q_whatSupportNeeded(): This.GoalSettingSelfReviewAnswer {
        return this.θq_whatSupportNeeded?.()
    }

    set q_whatSupportNeeded(q_whatSupportNeeded) {
        this.θq_whatSupportNeeded.set(LowgileDataUtil.coerceDataType(q_whatSupportNeeded, 'This.GoalSettingSelfReviewAnswer', false, true))
    }

    get q_howDoingOverall(): This.GoalSettingSelfReviewAnswer {
        return this.θq_howDoingOverall?.()
    }

    set q_howDoingOverall(q_howDoingOverall) {
        this.θq_howDoingOverall.set(LowgileDataUtil.coerceDataType(q_howDoingOverall, 'This.GoalSettingSelfReviewAnswer', false, true))
    }

    get q_otherComments(): This.GoalSettingSelfReviewAnswer {
        return this.θq_otherComments?.()
    }

    set q_otherComments(q_otherComments) {
        this.θq_otherComments.set(LowgileDataUtil.coerceDataType(q_otherComments, 'This.GoalSettingSelfReviewAnswer', false, true))
    }

    get developmentGoals(): Toolbox.GoalSettingGoal[] {
        return this.θdevelopmentGoals?.()
    }

    set developmentGoals(developmentGoals) {
        this.θdevelopmentGoals.set(LowgileDataUtil.coerceDataType(developmentGoals, Toolbox.GoalSettingGoal, true, true))
        this.developmentGoals?.forEach?.(item => { if (item && "goalSetting_developmentGoal" in item) item.goalSetting_developmentGoal = this as any })
    }

    get performanceGoals(): Toolbox.GoalSettingGoal[] {
        return this.θperformanceGoals?.()
    }

    set performanceGoals(performanceGoals) {
        this.θperformanceGoals.set(LowgileDataUtil.coerceDataType(performanceGoals, Toolbox.GoalSettingGoal, true, true))
        this.performanceGoals?.forEach?.(item => { if (item && "goalSetting_performanceGoal" in item) item.goalSetting_performanceGoal = this as any })
    }

    get previousGoalSetting(): Toolbox.GoalSetting {
        return this.θpreviousGoalSetting?.()
    }

    set previousGoalSetting(previousGoalSetting) {
        this.θpreviousGoalSetting.set(LowgileDataUtil.coerceDataType(previousGoalSetting, Toolbox.GoalSetting, false, true))
        if (previousGoalSetting) {
            this.θpreviousGoalSettingId.set(previousGoalSetting.id)
        } else if (previousGoalSetting === null && previousGoalSetting) {
            this.θpreviousGoalSettingId.set(null)
        }
    }

    get previousGoalSettingId(): Toolbox.GoalSetting.Id {
        return this.θpreviousGoalSettingId?.()
    }

    set previousGoalSettingId(previousGoalSettingId) {
        if (previousGoalSettingId === null) this.θpreviousGoalSetting.set(null)
        if (this.previousGoalSetting?.id && previousGoalSettingId != this.previousGoalSetting.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θpreviousGoalSettingId.set(LowgileDataUtil.coerceDataType(previousGoalSettingId, 'Toolbox.GoalSetting.Id', false, true))
    }

    get cycle(): Toolbox.GoalSettingCycle {
        return this.θcycle?.()
    }

    set cycle(cycle) {
        this.θcycle.set(LowgileDataUtil.coerceDataType(cycle, Toolbox.GoalSettingCycle, false, true))
        if (cycle) {
            this.θcycleId.set(cycle.id)
        } else if (cycle === null && cycle) {
            this.θcycleId.set(null)
        }
    }

    get cycleId(): Toolbox.GoalSettingCycle.Id {
        return this.θcycleId?.()
    }

    set cycleId(cycleId) {
        if (cycleId === null) this.θcycle.set(null)
        if (this.cycle?.id && cycleId != this.cycle.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θcycleId.set(LowgileDataUtil.coerceDataType(cycleId, 'Toolbox.GoalSettingCycle.Id', false, true))
    }

    get futureDevelopmentGoals(): Toolbox.GoalSettingGoal[] {
        return this.θfutureDevelopmentGoals?.()
    }

    set futureDevelopmentGoals(futureDevelopmentGoals) {
        this.θfutureDevelopmentGoals.set(LowgileDataUtil.coerceDataType(futureDevelopmentGoals, Toolbox.GoalSettingGoal, true, true))
        this.futureDevelopmentGoals?.forEach?.(item => { if (item && "goalSetting_futureDevelopmentGoal" in item) item.goalSetting_futureDevelopmentGoal = this as any })
    }

    get futurePerformanceGoals(): Toolbox.GoalSettingGoal[] {
        return this.θfuturePerformanceGoals?.()
    }

    set futurePerformanceGoals(futurePerformanceGoals) {
        this.θfuturePerformanceGoals.set(LowgileDataUtil.coerceDataType(futurePerformanceGoals, Toolbox.GoalSettingGoal, true, true))
        this.futurePerformanceGoals?.forEach?.(item => { if (item && "goalSetting_futurePerformanceGoal" in item) item.goalSetting_futurePerformanceGoal = this as any })
    }

    get attachments(): Toolbox.GoalSettingAttachment[] {
        return this.θattachments?.()
    }

    set attachments(attachments) {
        this.θattachments.set(LowgileDataUtil.coerceDataType(attachments, Toolbox.GoalSettingAttachment, true, true))
        this.attachments?.forEach?.(item => { if (item && "goalSetting" in item) item.goalSetting = this as any })
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    get nextAction(): string {
        if (!this.status.nextAction) return ''
        return `${this.status.managerShouldAct ? 'Manager' : 'Employee'} to ${this.status.nextAction}`
    }

    get nextActionDeadline(): Date {
        if (!this.status.nextAction) return undefined
        if (this.status.employeeCanEdit) {
            return this.cycle?.goalsDeadline
        }
        if (this.status.isSelfReviewPending) {
            return this.cycle?.selfReviewDeadline
        }
        if (this.status.isSelfReviewDone) {
            return this.cycle?.managerReviewDeadline
        }
    }

    get nextActionDeadlineStr(): string {
        const deadline = this.nextActionDeadline
        if (!deadline) return ''
        return Sys.Date.format(deadline, 'dd.MM.yyyy')
    }

    constructor(init?: Partial<Toolbox__GoalSetting>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                developmentGoals: [],
                performanceGoals: [],
                futureDevelopmentGoals: [],
                futurePerformanceGoals: [],
                attachments: [],
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => LowgileDataUtil.assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Toolbox__GoalSetting()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Toolbox__GoalSetting>, restrictToClass?: Class<Partial<Toolbox__GoalSetting>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = ""
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            get employee() { return System.UserIdAndName.$getSchema() },
            get manager() { return System.UserIdAndName.$getSchema() },
            get status() { return Toolbox.GoalSettingStatus.$getSchema() },
            get q_whatWentWell() { return Toolbox.GoalSettingSelfReviewAnswer.$getSchema() },
            get q_whatWasDifficult() { return Toolbox.GoalSettingSelfReviewAnswer.$getSchema() },
            get q_whatToDevelop() { return Toolbox.GoalSettingSelfReviewAnswer.$getSchema() },
            get q_whatSupportNeeded() { return Toolbox.GoalSettingSelfReviewAnswer.$getSchema() },
            get q_howDoingOverall() { return Toolbox.GoalSettingSelfReviewAnswer.$getSchema() },
            get q_otherComments() { return Toolbox.GoalSettingSelfReviewAnswer.$getSchema() },
            get developmentGoals() { return z.array(Toolbox.GoalSettingGoal.$getSchema()) },
            get performanceGoals() { return z.array(Toolbox.GoalSettingGoal.$getSchema()) },
            get previousGoalSetting() { return Toolbox.GoalSetting.$getSchema() },
            get previousGoalSettingId() { return z.number() },
            get cycle() { return Toolbox.GoalSettingCycle.$getSchema() },
            get cycleId() { return z.number() },
            get futureDevelopmentGoals() { return z.array(Toolbox.GoalSettingGoal.$getSchema()) },
            get futurePerformanceGoals() { return z.array(Toolbox.GoalSettingGoal.$getSchema()) },
            get attachments() { return z.array(Toolbox.GoalSettingAttachment.$getSchema()) },
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return Toolbox__GoalSetting.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('employee', 'manager', 'status$id', 'q_whatWentWell', 'q_whatWasDifficult', 'q_whatToDevelop', 'q_whatSupportNeeded', 'q_howDoingOverall', 'q_otherComments', 'developmentGoals', 'performanceGoals', 'previousGoalSetting', 'previousGoalSettingId', 'cycle', 'cycleId', 'futureDevelopmentGoals', 'futurePerformanceGoals', 'attachments', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    static async save(gsClient: This.GoalSetting, action: This.GoalSettingSaveAction): Promise<{ newStatusId: This.GoalSettingStatus.Id, nextGsId: This.GoalSetting.Id }> {
        const args = [...arguments]
        const result = await ExecutionService.executeMethodAndReturnData<{ newStatusId: This.GoalSettingStatus.Id, nextGsId: This.GoalSetting.Id }>('Entity', 'Toolbox', 'GoalSetting', undefined, 'save', args)
        return result
    }

    getColumnVisibility(viewMode: This.GoalSettingViewMode): This.GoalSettingGoalColumnVisibility {
        const { status } = this
        const showRejectionComments = (
            ((viewMode.isHr || viewMode.isEmployee) && status.employeeCanSeeRejectionComments) ||
            ((viewMode.isHr || viewMode.isManager) && status.managerCanSeeRejectionComments)
        )
        const showSelfReview = (
            ((viewMode.isHr || viewMode.isEmployee) && status.employeeCanSeeEmployeeReview) ||
            (viewMode.isManager && status.managerCanSeeEmployeeReview)
        )
        const showManagerReview = (
            ((viewMode.isHr || viewMode.isManager) && status.managerCanSeeManagerReview) ||
            (viewMode.isEmployee && status.employeeCanSeeManagerReview)
        )
        const columnCount = 1 + Number(showRejectionComments) + Number(showSelfReview) + Number(showManagerReview)

        return {
            showRejectionComments,
            showSelfReview,
            showManagerReview,
            columnCount,
        }
    }

    getAllSelfReviewAnswers(): This.GoalSettingSelfReviewAnswer[] {
        return [
            this.q_howDoingOverall,
            this.q_otherComments,
            this.q_whatSupportNeeded,
            this.q_whatToDevelop,
            this.q_whatWasDifficult,
            this.q_whatWentWell,
        ]
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Toolbox__GoalSetting {
        return equal(this, other)
    }
}

namespace Toolbox__GoalSetting { }

export import GoalSetting = Toolbox__GoalSetting
setTimeout(() => {
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSetting.prototype, 'employee')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSetting.prototype, 'manager')
    jsonProperty(() => Toolbox.GoalSettingSelfReviewAnswer)(Toolbox__GoalSetting.prototype, 'q_whatWentWell')
    jsonProperty(() => Toolbox.GoalSettingSelfReviewAnswer)(Toolbox__GoalSetting.prototype, 'q_whatWasDifficult')
    jsonProperty(() => Toolbox.GoalSettingSelfReviewAnswer)(Toolbox__GoalSetting.prototype, 'q_whatToDevelop')
    jsonProperty(() => Toolbox.GoalSettingSelfReviewAnswer)(Toolbox__GoalSetting.prototype, 'q_whatSupportNeeded')
    jsonProperty(() => Toolbox.GoalSettingSelfReviewAnswer)(Toolbox__GoalSetting.prototype, 'q_howDoingOverall')
    jsonProperty(() => Toolbox.GoalSettingSelfReviewAnswer)(Toolbox__GoalSetting.prototype, 'q_otherComments')
    jsonArrayProperty(() => Toolbox.GoalSettingGoal)(Toolbox__GoalSetting.prototype, 'developmentGoals')
    jsonArrayProperty(() => Toolbox.GoalSettingGoal)(Toolbox__GoalSetting.prototype, 'performanceGoals')
    jsonProperty(() => Toolbox.GoalSetting)(Toolbox__GoalSetting.prototype, 'previousGoalSetting')
    jsonProperty(() => Toolbox.GoalSetting.Id)(Toolbox__GoalSetting.prototype, 'previousGoalSettingId')
    jsonProperty(() => Toolbox.GoalSettingCycle)(Toolbox__GoalSetting.prototype, 'cycle')
    jsonProperty(() => Toolbox.GoalSettingCycle.Id)(Toolbox__GoalSetting.prototype, 'cycleId')
    jsonArrayProperty(() => Toolbox.GoalSettingGoal)(Toolbox__GoalSetting.prototype, 'futureDevelopmentGoals')
    jsonArrayProperty(() => Toolbox.GoalSettingGoal)(Toolbox__GoalSetting.prototype, 'futurePerformanceGoals')
    jsonArrayProperty(() => Toolbox.GoalSettingAttachment)(Toolbox__GoalSetting.prototype, 'attachments')
    jsonProperty(() => Date)(Toolbox__GoalSetting.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSetting.prototype, 'createdBy')
    jsonProperty(() => Date)(Toolbox__GoalSetting.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSetting.prototype, 'updatedBy')
    jsonProperty(() => Date)(Toolbox__GoalSetting.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSetting.prototype, 'deletedBy')
    jsonProperty(() => Number)(Toolbox__GoalSetting.prototype, 'versionNumber')
})
@jsonClass('Toolbox.GoalSetting.ForSelectionList')
class Toolbox__GoalSetting__ForSelectionList {
    @jsonProperty(() => Toolbox__GoalSetting.Id)
    id: Toolbox__GoalSetting.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "cycle", "cycleId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["nextAction", "nextActionDeadline", "nextActionDeadlineStr"] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "cycle", "cycleId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber", "nextAction", "nextActionDeadline", "nextActionDeadlineStr"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "cycle", "cycleId", "createdOn", "updatedOn", "deletedOn", "versionNumber", "nextAction", "nextActionDeadline", "nextActionDeadlineStr"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "cycle": "Toolbox.GoalSettingCycle", "cycleId": "Toolbox.GoalSettingCycle.Id", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "nextAction": "string", "nextActionDeadline": "Date", "nextActionDeadlineStr": "string", "id": "number" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["status"] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["ForSelectionList", "ForList"] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ cycle: () => Toolbox.GoalSettingCycle } as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θcycle = Signals.proxySignalDeferred<Toolbox.GoalSettingCycle>(() => (undefined) as any);
    private readonly θcycleId = Signals.proxySignalDeferred<Toolbox.GoalSettingCycle.Id>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Toolbox.GoalSetting.ForSelectionList' {
        return 'Toolbox.GoalSetting.ForSelectionList'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Toolbox.GoalSetting.ForSelectionList' {
        return 'Toolbox.GoalSetting.ForSelectionList'
    }

    static get __baseType(): 'Toolbox.GoalSetting' {
        return 'Toolbox.GoalSetting'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Toolbox.GoalSetting' {
        return 'Toolbox.GoalSetting'
    }

    get [BoInfoSymbol]() {
        return Toolbox__GoalSetting__ForSelectionList[BoInfoSymbol]
    }

    get cycle(): Toolbox.GoalSettingCycle {
        return this.θcycle?.()
    }

    set cycle(cycle) {
        this.θcycle.set(LowgileDataUtil.coerceDataType(cycle, Toolbox.GoalSettingCycle, false, true))
        if (cycle) {
            this.θcycleId.set(cycle.id)
        } else if (cycle === null && cycle) {
            this.θcycleId.set(null)
        }
    }

    get cycleId(): Toolbox.GoalSettingCycle.Id {
        return this.θcycleId?.()
    }

    set cycleId(cycleId) {
        if (cycleId === null) this.θcycle.set(null)
        if (this.cycle?.id && cycleId != this.cycle.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θcycleId.set(LowgileDataUtil.coerceDataType(cycleId, 'Toolbox.GoalSettingCycle.Id', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Toolbox__GoalSetting__ForSelectionList>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => LowgileDataUtil.assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Toolbox__GoalSetting__ForSelectionList()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Toolbox__GoalSetting__ForSelectionList>, restrictToClass?: Class<Partial<Toolbox__GoalSetting__ForSelectionList>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = "ForSelectionList"
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            get cycle() { return Toolbox.GoalSettingCycle.$getSchema() },
            get cycleId() { return z.number() },
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return Toolbox__GoalSetting__ForSelectionList.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('cycle', 'cycleId', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Toolbox__GoalSetting__ForSelectionList {
        return equal(this, other)
    }
}

namespace Toolbox__GoalSetting__ForSelectionList { }

export import ForSelectionList = Toolbox__GoalSetting__ForSelectionList
setTimeout(() => {
    jsonProperty(() => Toolbox.GoalSettingCycle)(Toolbox__GoalSetting__ForSelectionList.prototype, 'cycle')
    jsonProperty(() => Toolbox.GoalSettingCycle.Id)(Toolbox__GoalSetting__ForSelectionList.prototype, 'cycleId')
    jsonProperty(() => Date)(Toolbox__GoalSetting__ForSelectionList.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSetting__ForSelectionList.prototype, 'createdBy')
    jsonProperty(() => Date)(Toolbox__GoalSetting__ForSelectionList.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSetting__ForSelectionList.prototype, 'updatedBy')
    jsonProperty(() => Date)(Toolbox__GoalSetting__ForSelectionList.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSetting__ForSelectionList.prototype, 'deletedBy')
    jsonProperty(() => Number)(Toolbox__GoalSetting__ForSelectionList.prototype, 'versionNumber')
})
@jsonClass('Toolbox.GoalSetting.ForList')
class Toolbox__GoalSetting__ForList {
    @jsonProperty(() => Toolbox__GoalSetting.Id)
    id: Toolbox__GoalSetting.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "employee", "manager", "status", "status$id", "cycle", "cycleId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["nextAction", "nextActionDeadline", "nextActionDeadlineStr"] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "employee", "manager", "status", "status$id", "cycle", "cycleId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber", "nextAction", "nextActionDeadline", "nextActionDeadlineStr"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "employee", "manager", "status", "cycle", "cycleId", "createdOn", "updatedOn", "deletedOn", "versionNumber", "nextAction", "nextActionDeadline", "nextActionDeadlineStr"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "employee": "System.UserIdAndName", "manager": "System.UserIdAndName", "status": "Toolbox.GoalSettingStatus", "status$id": "string", "cycle": "Toolbox.GoalSettingCycle", "cycleId": "Toolbox.GoalSettingCycle.Id", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "nextAction": "string", "nextActionDeadline": "Date", "nextActionDeadlineStr": "string", "id": "number" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["status"] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["ForSelectionList", "ForList"] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ cycle: () => Toolbox.GoalSettingCycle } as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({ employee: () => System.UserIdAndName, manager: () => System.UserIdAndName } as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θemployee = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θmanager = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θstatus = Signals.proxySignalDeferred<This.GoalSettingStatus>(() => (new This.GoalSettingStatus(This.GoalSettingStatus.Draft)) as any);
    private readonly θcycle = Signals.proxySignalDeferred<Toolbox.GoalSettingCycle>(() => (undefined) as any);
    private readonly θcycleId = Signals.proxySignalDeferred<Toolbox.GoalSettingCycle.Id>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Toolbox.GoalSetting.ForList' {
        return 'Toolbox.GoalSetting.ForList'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Toolbox.GoalSetting.ForList' {
        return 'Toolbox.GoalSetting.ForList'
    }

    static get __baseType(): 'Toolbox.GoalSetting' {
        return 'Toolbox.GoalSetting'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Toolbox.GoalSetting' {
        return 'Toolbox.GoalSetting'
    }

    get [BoInfoSymbol]() {
        return Toolbox__GoalSetting__ForList[BoInfoSymbol]
    }

    get employee(): System.UserIdAndName {
        return this.θemployee?.()
    }

    set employee(employee) {
        this.θemployee.set(LowgileDataUtil.coerceDataType(employee, 'System.UserIdAndName', false, true))
    }

    get manager(): System.UserIdAndName {
        return this.θmanager?.()
    }

    set manager(manager) {
        this.θmanager.set(LowgileDataUtil.coerceDataType(manager, 'System.UserIdAndName', false, true))
    }

    get status(): This.GoalSettingStatus {
        return this.θstatus?.()
    }

    set status(status: This.GoalSettingStatus | This.GoalSettingStatus.Id) {
        this.θstatus().θupdate(status)
    }

    @jsonProperty(String)
    get 'status$id'(): This.GoalSettingStatus.Id {
        return this.θstatus?.()?.id
    }

    set 'status$id'(status: string) {
        this.θstatus().θupdate(status as This.GoalSettingStatus.Id)
    }

    get cycle(): Toolbox.GoalSettingCycle {
        return this.θcycle?.()
    }

    set cycle(cycle) {
        this.θcycle.set(LowgileDataUtil.coerceDataType(cycle, Toolbox.GoalSettingCycle, false, true))
        if (cycle) {
            this.θcycleId.set(cycle.id)
        } else if (cycle === null && cycle) {
            this.θcycleId.set(null)
        }
    }

    get cycleId(): Toolbox.GoalSettingCycle.Id {
        return this.θcycleId?.()
    }

    set cycleId(cycleId) {
        if (cycleId === null) this.θcycle.set(null)
        if (this.cycle?.id && cycleId != this.cycle.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θcycleId.set(LowgileDataUtil.coerceDataType(cycleId, 'Toolbox.GoalSettingCycle.Id', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    get nextAction(): string {
        if (!this.status.nextAction) return ''
        return `${this.status.managerShouldAct ? 'Manager' : 'Employee'} to ${this.status.nextAction}`
    }

    get nextActionDeadline(): Date {
        if (!this.status.nextAction) return undefined
        if (this.status.employeeCanEdit) {
            return this.cycle?.goalsDeadline
        }
        if (this.status.isSelfReviewPending) {
            return this.cycle?.selfReviewDeadline
        }
        if (this.status.isSelfReviewDone) {
            return this.cycle?.managerReviewDeadline
        }
    }

    get nextActionDeadlineStr(): string {
        const deadline = this.nextActionDeadline
        if (!deadline) return ''
        return Sys.Date.format(deadline, 'dd.MM.yyyy')
    }

    constructor(init?: Partial<Toolbox__GoalSetting__ForList>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => LowgileDataUtil.assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Toolbox__GoalSetting__ForList()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Toolbox__GoalSetting__ForList>, restrictToClass?: Class<Partial<Toolbox__GoalSetting__ForList>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = "ForList"
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            get employee() { return System.UserIdAndName.$getSchema() },
            get manager() { return System.UserIdAndName.$getSchema() },
            get status() { return Toolbox.GoalSettingStatus.$getSchema() },
            get cycle() { return Toolbox.GoalSettingCycle.$getSchema() },
            get cycleId() { return z.number() },
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return Toolbox__GoalSetting__ForList.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('employee', 'manager', 'status$id', 'cycle', 'cycleId', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    getColumnVisibility(viewMode: This.GoalSettingViewMode): This.GoalSettingGoalColumnVisibility {
        const { status } = this
        const showRejectionComments = (
            ((viewMode.isHr || viewMode.isEmployee) && status.employeeCanSeeRejectionComments) ||
            ((viewMode.isHr || viewMode.isManager) && status.managerCanSeeRejectionComments)
        )
        const showSelfReview = (
            ((viewMode.isHr || viewMode.isEmployee) && status.employeeCanSeeEmployeeReview) ||
            (viewMode.isManager && status.managerCanSeeEmployeeReview)
        )
        const showManagerReview = (
            ((viewMode.isHr || viewMode.isManager) && status.managerCanSeeManagerReview) ||
            (viewMode.isEmployee && status.employeeCanSeeManagerReview)
        )
        const columnCount = 1 + Number(showRejectionComments) + Number(showSelfReview) + Number(showManagerReview)

        return {
            showRejectionComments,
            showSelfReview,
            showManagerReview,
            columnCount,
        }
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Toolbox__GoalSetting__ForList {
        return equal(this, other)
    }
}

namespace Toolbox__GoalSetting__ForList { }

export import ForList = Toolbox__GoalSetting__ForList
setTimeout(() => {
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSetting__ForList.prototype, 'employee')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSetting__ForList.prototype, 'manager')
    jsonProperty(() => Toolbox.GoalSettingCycle)(Toolbox__GoalSetting__ForList.prototype, 'cycle')
    jsonProperty(() => Toolbox.GoalSettingCycle.Id)(Toolbox__GoalSetting__ForList.prototype, 'cycleId')
    jsonProperty(() => Date)(Toolbox__GoalSetting__ForList.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSetting__ForList.prototype, 'createdBy')
    jsonProperty(() => Date)(Toolbox__GoalSetting__ForList.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSetting__ForList.prototype, 'updatedBy')
    jsonProperty(() => Date)(Toolbox__GoalSetting__ForList.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSetting__ForList.prototype, 'deletedBy')
    jsonProperty(() => Number)(Toolbox__GoalSetting__ForList.prototype, 'versionNumber')
})

export const GoalSettingθId = Number;

export type GoalSettingθId = number;

namespace Toolbox__GoalSetting {
    export type Id = NominalType<number, 'Toolbox.GoalSetting'>
    export type ForSelectionList = Toolbox__GoalSetting__ForSelectionList
    export type ForList = Toolbox__GoalSetting__ForList
}
Toolbox__GoalSetting.ForSelectionList = Toolbox__GoalSetting__ForSelectionList
Toolbox__GoalSetting.ForList = Toolbox__GoalSetting__ForList
